function checkTermsVer (userAttributes, targetName, targetValue, targetAttr) {
  const leng = userAttributes.length;
  for (let i = 0; i < leng; i++) {
    if (userAttributes[i].Name === targetName) {
      // 属性がある
      const myJson = JSON.parse(userAttributes[i].Value);
      if (myJson.hasOwnProperty(targetAttr)) {
        // value内にtargetAttrが存在した
        // バージョンが小さければtrue
        return myJson[targetAttr] < targetValue;
      }
    }
  }
  // 一通り見た結果該当する属性が見つからなかった
  return true;
}
export default checkTermsVer;